/* ═══════════════════════════════════════════════════════════════════════════
   UPPER BODEGA — PDP variant picker.
   ───────────────────────────────────────────────────────────────────────────
   The design's size row is a set of pills, not a <select>, so the theme's own
   variant-picker markup could not be reused. This wires those pills to the
   product's real variant data:

     · click a pill  → that option value becomes selected
     · find the variant whose option values all match
     · update the form's variant id, the button's price and availability,
       the "Only N left" line, and the URL (so a refresh or a share keeps it)

   Reads a JSON blob the section prints, rather than fetching — the data is
   already on the page and this must feel instant.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function init(root) {
    var dataEl = root.querySelector('[data-ub-variants]');
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var form     = root.querySelector('form.ub-buy-form');
    var idInput  = root.querySelector('[data-variant-id]');
    var addBtn   = root.querySelector('.buy__add');
    var stockEl  = root.querySelector('.stock');
    var sticky   = root.querySelector('.sticky-buy__btn');
    var money    = dataEl.getAttribute('data-money-format') || '${{amount}}';
    var addLabel = addBtn ? (addBtn.getAttribute('data-label') || 'Add to bag') : 'Add to bag';
    var soldOut  = addBtn ? (addBtn.getAttribute('data-soldout') || 'Sold out') : 'Sold out';
    var lowAt    = parseInt(root.getAttribute('data-low-stock') || '10', 10);

    function formatMoney(cents) {
      var v = (cents / 100).toFixed(2).replace(/\.00$/, '');
      return money.replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/, v).replace(/\{\{[^}]*\}\}/, v);
    }

    function selected() {
      return Array.prototype.map.call(
        root.querySelectorAll('.opts'),
        function (group) {
          var on = group.querySelector('.opt[aria-pressed="true"]');
          return on ? on.getAttribute('data-value') : null;
        });
    }

    function match(values) {
      return variants.find(function (v) {
        return values.every(function (val, i) {
          return val === null || v.options[i] === val;
        });
      });
    }

    function apply(v) {
      if (!v) return;
      if (idInput) idInput.value = v.id;

      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available
          ? addLabel + ' — ' + formatMoney(v.price)
          : soldOut;
      }

      if (sticky) {
        sticky.disabled = !v.available;
        sticky.textContent = v.available
          ? (sticky.getAttribute('data-label') || 'Add to bag') + ' — ' + formatMoney(v.price)
          : (sticky.getAttribute('data-soldout') || 'Sold out');
      }

      if (stockEl) {
        var show = v.available && v.inventory_management === 'shopify' &&
                   v.inventory_quantity > 0 && v.inventory_quantity <= lowAt;
        stockEl.textContent = show ? 'Only ' + v.inventory_quantity + ' left' : '';
        stockEl.style.display = show ? '' : 'none';
      }

      /* keep the URL honest, so a refresh or a shared link lands on this variant */
      if (window.history && history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u);
      }
    }

    /* ── ADD TO BAG, without leaving the page ───────────────────────────────
       The form posted normally, so the PDP reloaded into /cart while a card
       adds silently to the drawer — two different behaviours for the same act.
       This routes the PDP through the same path the card uses:
         · the postal gate first (global.js gates every add on a postcode)
         · POST /cart/add.js with the drawer's sections so it re-renders
         · fall back to a normal submit if anything is missing
    */
    if (form) {
      form.addEventListener('submit', function (e) {
        var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        if (!drawer || typeof fetchConfig !== 'function') return;   // let it post normally

        if (!localStorage.getItem('postal_code') || !localStorage.getItem('delivery_city')) {
          e.preventDefault();
          var popup = document.querySelector('delivery-popup');
          window.__ubPendingAdd = function () { form.requestSubmit ? form.requestSubmit() : form.submit(); };
          if (popup && popup.showPopup) popup.showPopup(popup);
          return;
        }

        e.preventDefault();
        if (addBtn) addBtn.setAttribute('aria-busy', 'true');

        var body = {
          id: idInput ? idInput.value : null,
          quantity: 1,
          sections: drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : []
        };
        var cfg = fetchConfig('json');
        cfg.headers['X-Requested-With'] = 'XMLHttpRequest';
        cfg.body = JSON.stringify(body);

        fetch('/cart/add.js', cfg)
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) { window.location.href = '/cart'; return; }
            if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
            if (drawer.renderContents) drawer.renderContents(res);

            /* ── OPEN THE DRAWER ────────────────────────────────────────────
               cart-drawer.js:103 has `//this.open();` COMMENTED OUT — the
               theme's own code, from the baseline, never touched here. That is
               correct for a card `+` (which paints its own pill state via
               ub-cart.js and never opens the bag), but on a PDP the button is
               the whole action: nothing repaints, so a successful add looked
               like a dead button. The item WAS added — POST /cart/add.js
               returned 200 and the badge incremented — there was simply no
               feedback anywhere on screen.
               Opening the drawer is what the approved design shows and what
               the bag count implies already happened.
               To revert: delete this block; adds go back to silent.          */
            if (drawer.open) setTimeout(function () { drawer.open(); }, 0);
          })
          .catch(function () { window.location.href = '/cart'; })
          .finally(function () { if (addBtn) addBtn.removeAttribute('aria-busy'); });
      });
    }

    /* the sticky bar submits the same form, so it takes the same path:
       postal gate, /cart/add.js, drawer re-render */
    if (sticky && form) {
      sticky.addEventListener('click', function () {
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.opt');
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      var group = btn.closest('.opts');
      group.querySelectorAll('.opt').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b === btn));
      });
      apply(match(selected()));
    });
  }

  /* ── INGREDIENT CLICK-TO-EXPLAIN ──────────────────────────────────────────
     Only items that actually carry a note are interactive — the Liquid gives
     them role="button" and data-ub-note. One open at a time, because the panel
     is a single shared region; clicking the open one closes it and restores the
     hint. Keyboard works because they are real buttons in the accessibility
     tree, so Enter and Space have to be handled explicitly.                  */
  function initIngredients(root) {
    var list = root.querySelector('.ing-list');
    var panel = root.querySelector('.ing-exp');
    if (!list || !panel) return;

    var hint = panel.querySelector('.hint');
    var hintText = hint ? hint.textContent : '';

    function close() {
      list.querySelectorAll('[data-ub-note]').forEach(function (el) {
        el.setAttribute('aria-expanded', 'false');
      });
      panel.innerHTML = '<span class="hint"></span>';
      panel.querySelector('.hint').textContent = hintText;
    }

    function open(el) {
      list.querySelectorAll('[data-ub-note]').forEach(function (o) {
        o.setAttribute('aria-expanded', String(o === el));
      });
      panel.textContent = el.getAttribute('data-ub-note');
    }

    function toggle(el) {
      if (el.getAttribute('aria-expanded') === 'true') close();
      else open(el);
    }

    list.addEventListener('click', function (e) {
      var el = e.target.closest('[data-ub-note]');
      if (el) toggle(el);
    });
    list.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var el = e.target.closest('[data-ub-note]');
      if (!el) return;
      e.preventDefault();
      toggle(el);
    });
  }

  function boot() {
    document.querySelectorAll('.ub-pdp').forEach(function (r) { init(r); initIngredients(r); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
